import React from 'react';
import { Label } from 'semantic-ui-react';
import { STATUSES } from 'constants/constants';
import CarrierLogo from 'components/CarrierLogo/CarrierLogo';
import DateColumn from 'components/DateColumn/DateColumn';
import ECILogo from 'components/ECILogo/ECILogo';

export const getColumns = (renderActions = () => {}) => [
  {
    Header: 'Nº de orden',
    disableSortBy: true,
    accessor: 'reference',
    width: 280,
  },
  {
    Header: 'Creación',
    disableSortBy: true,
    accessor: 'creation_date',
    width: 120,
    Cell: ({ value }) => <DateColumn date={value} />,
  },
  {
    Header: 'Almacén',
    disableSortBy: true,
    accessor: 'warehouse',
    width: 120,
    textAlign: 'center',
    Cell: ({ value }) => value?.warehouse || '',
  },
  {
    Header: 'Marketplace',
    disableSortBy: true,
    accessor: 'marketplace',
    width: 120,
    textAlign: 'center',
    Cell: ({ value }) => value?.name || '',
  },
  {
    Header: 'Bultos',
    disableSortBy: true,
    width: 80,
    textAlign: 'center',
    Cell: ({ row }) => {
      return `${row.original?.remaining_labels || 0}/${
        row.original?.total_labels || '-'
      }`;
    },
  },
  {
    Header: 'Agencia',
    disableSortBy: true,
    accessor: 'agency',
    textAlign: 'center',
    width: 90,
    Cell: ({ value }) => <CarrierLogo code={value?.agency_code} />,
  },
  {
    Header: 'Externo',
    disableSortBy: true,
    accessor: 'has_external_labels',
    width: 70,
    textAlign: 'center',
    Cell: ({ value }) => (value ? <ECILogo /> : null),
  },
  {
    Header: 'Estado',
    accessor: 'status',
    disableSortBy: true,
    width: 160,
    Cell: ({ value }) => (
      <Label color={STATUSES[value]?.color || 'brown'}>
        {STATUSES[value]?.text || value}
      </Label>
    ),
  },
  {
    Header: 'Acciones',
    disableSortBy: true,
    textAlign: 'right',
    width: 100,
    Cell: ({ row }) => {
      return renderActions(row.original);
    },
  },
];
